var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import Typography from "../Typography";
import PropTypes from "prop-types";
export var Pill = function (_a) {
    var _b;
    var label = _a.label, className = _a.className, _c = _a.variant, variant = _c === void 0 ? "neutral" : _c, _d = _a.contrast, contrast = _d === void 0 ? "high" : _d, subLabel = _a.subLabel, icon = _a.icon, _e = _a.iconPosition, iconPosition = _e === void 0 ? "left" : _e, otherProps = __rest(_a, ["label", "className", "variant", "contrast", "subLabel", "icon", "iconPosition"]);
    var PREFIX = "mex-pill";
    var classnames = classNames((_b = {},
        _b[PREFIX] = true,
        _b["".concat(PREFIX, "--").concat(contrast)] = true,
        _b["".concat(PREFIX, "--").concat(variant)] = true,
        _b["".concat(PREFIX, "--icon-right")] = iconPosition === "right",
        _b[className || ""] = !!className,
        _b));
    return (_jsxs("div", __assign({ className: classnames }, otherProps, { children: [icon && iconPosition === "left" && icon, _jsx(Typography, __assign({ variant: "metadataRegular" }, { children: label })), subLabel && (_jsx(Typography, __assign({ variant: "metadataSemibold", className: "".concat(PREFIX, "__sublabel") }, { children: subLabel }))), icon && iconPosition === "right" && icon] })));
};
Pill.propTypes = {
    label: PropTypes.string.isRequired,
    subLabel: PropTypes.string,
    variant: PropTypes.oneOf(["neutral", "informative", "positive", "warning", "alert"]),
    contrast: PropTypes.oneOf(["low", "high"]),
    icon: PropTypes.node,
    iconPosition: PropTypes.oneOf(["left", "right"]),
};
Pill.defaultProps = {
    variant: "neutral",
    iconPosition: "left",
    contrast: "low",
};
export default Pill;
